export const defineMinimumPricePerLesson = lpks => {
  if (lpks.length === 0) return null
  return Math.min(...lpks.map(item => item.priceInCents / item.quantity))
}
